import React, { useEffect } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { refreshToken } from '../store/slices/authSlice';
import GlobalMessageMonitor from './GlobalMessageMonitor';

const ProtectedRoute = ({ allowedUserTypes, blockViewOnly = false }) => {
  const { user, isAuthenticated, accessToken } = useSelector((state) => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated && accessToken) {
      dispatch(refreshToken());
    }
  }, [isAuthenticated, accessToken, dispatch]);

  if (!isAuthenticated) {
    // Redirect to home if not authenticated
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (allowedUserTypes && !allowedUserTypes.includes(user.role)) {
    // Redirect to home if user type is not allowed
    return <Navigate to="/" replace />;
  }

  if (blockViewOnly && user?.isViewOnly) {
    // Redirect view-only customers away from payment-related pages
    return <Navigate to="/customer/dashboard" replace />;
  }

  return (
    <>
      <GlobalMessageMonitor />
      <Outlet />
    </>
  );
};

export default ProtectedRoute;
